import * as React from 'react'

import Typography from '@mui/material/Typography'
import Radio from '@mui/material/Radio'
import FormControlLabel, {
  formControlLabelClasses,
} from '@mui/material/FormControlLabel'
import { Theme, useTheme } from '@mui/material/styles'

const getStyles = (theme: Theme) => ({
  root: { margin: 0 },

  label: {
    fontSize: '16px',
    fontWeight: 'bold',
  },

  caption: {
    marginTop: theme.spacing(-0.6),
    marginLeft: theme.spacing(4.3),
    marginBottom: theme.spacing(2),
  },
})

export const RadioWithLabel: React.FC<{
  label: string
  helperText: string
  value: string
}> = ({ label, helperText, value }) => {
  const styles = getStyles(useTheme())

  return (
    <>
      <FormControlLabel
        control={<Radio />}
        value={value}
        sx={{
          ...styles.root,
          [`& .${formControlLabelClasses.label}`]: { ...styles.label },
        }}
        label={label}
      />
      <Typography sx={{ ...styles.caption }}>{helperText}</Typography>
    </>
  )
}
RadioWithLabel.displayName = 'RadioWithLabel'
